export const DEFAULT_ONBOARDING_STATUS = {
  all_customizations: false,
  all_key_steps: false,
  has_contact_spreadsheet_uploaded: false,
  has_firm_email_integrated: false,
  has_multiple_firm_members: false,
  has_sent_questionnaire: false,
  imported_prior_year_data: false,
  introduced_soraban_to_clients: false,
  updated_engagement_letter: false,
  updated_questionnaire_messaging: false,
  updated_questionnaire_question: false,
};
